import React from 'react'
import NaBar from "../components/NavBar";
import HeroImg2 from "../components/HeroImg2";
import Footer from "../components/Footer";

const Project = () => {
  return (
    <div>
      <NaBar/>
      <HeroImg2 heading="פרוייקטים" text=" "/>
      <Footer/>

    </div>
  );
}

export default Project
